import React, { FC } from 'react'
import { Container, IconButton } from '@mui/material'
import { Edit } from '@mui/icons-material'
import Loading from '../../../shared/loading'
import { BackButton } from '../../../../components/user-navigation/BackButton'
import { VehicleDetailsBlock } from './blocks/VehicleDetailsBlock'
import AddRegistration from '../add-registration'
import AddDealDocuments from '../add-deal-documents'
import { Article } from 'shared/Article'
import { Section } from 'shared/Section'
import { FormDrawerComponent } from 'shared/FormDrawerComponent'
import { useVehicleDetail } from './useVehicleDetail'
import { useEditVehicle } from './blocks/useEditVehicle'
import { EditVehicleForm } from './blocks/EditVehicleForm'

export const VehicleDetail: FC = () => {
  const {
    isLoading,
    vehicle,
    setDisplayDialogState,
    displayDialogState,
  } = useVehicleDetail()

  const {
    isEditDrawerOpen,
    setIsEditDrawerOpen,
    handleSave,
    getDefaultValues
  } = useEditVehicle(vehicle)

  if (isLoading) {
    return <Loading />
  }

  const { year, make, model, id, vin } = vehicle

  const dialogs = [
    <AddRegistration
      key="addRegistrationDialog"
      open={displayDialogState.addRegistrationDialog}
      handleClose={() => {
        setDisplayDialogState({
          ...displayDialogState,
          addRegistrationDialog: false,
        })
      }}
      id={id}
      vin={vin}
    />,
    <AddDealDocuments
      key="addDeadDocumentsDialog"
      open={displayDialogState.addDealDocumentsDialog}
      handleClose={() => {
        setDisplayDialogState({
          ...displayDialogState,
          addDealDocumentsDialog: false,
        })
      }}
      id={id}
      vin={vin}
    />,
  ]

  return (
    <Container>
      <BackButton lastPageRoute="/fleet" />

      <Article
        heading={`${year} ${make} ${model}`}
        headerHasBottomBorder={true}
      >
        {dialogs.map((dialog) => dialog)}

        <Section
          heading="Vehicle Details"
          headerButtons={
            vehicle && (
              <IconButton
                onClick={() => setIsEditDrawerOpen(true)}
                size="small"
                sx={{ color: 'text.primary' }}
                title="Edit Vehicle"
              >
                <Edit />
              </IconButton>
            )
          }
        >
          <VehicleDetailsBlock vehicle={vehicle} />
        </Section>

      </Article>

      {vehicle && (
        <FormDrawerComponent
          isDrawerOpen={isEditDrawerOpen}
          setIsDrawerOpen={setIsEditDrawerOpen}
          header="Edit Vehicle"
          handleSave={handleSave}
          defaultValues={getDefaultValues()}
          form={EditVehicleForm}
        />
      )}
    </Container>
  )
}
